import React, { useMemo, useState } from "react";
import { useAppTranslation } from "../../../i18n/useAppTranslation";
import { ReorderModal } from "../../../boxes/ReorderModal/ReorderModal";
import { reorderReferralSources } from "../../../Actions/referralSourcesActions";

export function ObOrder({ isLoading, sources, refetchSources }) {
  const { tCommon } = useAppTranslation.Common();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  const mappedSources = useMemo(() => {
    return sources
      ?.filter((source) => source.show_in_ob)
      ?.sort((a, b) => a.ob_order - b.ob_order)
      ?.map((source) => ({
        id: source.source_code,
        content: source.source_name,
      }));
  }, [sources]);

  const submit = (orderedSources) => {
    const sourceOrder = orderedSources.map((source) => source.id);
    setIsSaving(true);
    reorderReferralSources({ codes: sourceOrder })
      .then(() => {
        setIsModalOpen(false);
        refetchSources();
      })
      .finally(() => {
        setIsSaving(false);
      });
  };

  return (
    <>
      <button
        className="easy-link no-padding"
        onClick={() => setIsModalOpen(true)}
      >
        {tCommon("label.obOrder")}
      </button>
      {isModalOpen && (
        <ReorderModal
          isLoading={isLoading}
          isSaving={isSaving}
          isOpen={isModalOpen}
          data={mappedSources}
          onClose={() => setIsModalOpen(false)}
          title={tCommon("label.obOrder")}
          onSave={submit}
        />
      )}
    </>
  );
}
